import LoadingIconApp from './LoadingIconApp';
import './LoadingIconApp.scss';

const LoadingIconAppAbsolute = ({ size = 30, height = '100vh' }) => {
  return (
    <div className="loading_icon_app_absolute" style={{ height: height }}>
      <LoadingIconApp size={size} />
    </div>
  );
};

export default LoadingIconAppAbsolute;
